<template>
    <app-layout>
        <bax-header-banner :user="this.$store.state.auth.user" :orderStep="4" :order="orderInfo" headingMain="Review and Complete your Order" />

        <div class="bax-section bax-reviewsection">
            <div class="container">
                <!-- <div>
                    <vue-button color="link" class="d-flex align-items-center justify-content-center ml-auto">
                        <i class="icon-printer"></i> Print
                    </vue-button>
                </div> -->

                <order-summary v-on:refresh-order-summary="orderSummaryRefreshed" v-on:editRequired="orderInfo.editRequired = true;" checkValidDrugs="true"></order-summary>

                <div class="bax-divider"></div>

                <template v-if="authenticatedUser.baxterRoles.can_create_edit_orders">
                    <div class="bax-bg bax-bg-foot-link bax-review-content">
                        <h2>Next Step</h2>
                    <p v-if="isTPN()">Submit your order to our team for processing</p>
                    <p v-if="!isTPN()">Submit to our compounding team for processing.</p>
                        <p class="warning" v-if="orderInfo.editRequired">Some items in this order need to be reviewed. Please edit the red order lines and save them again.</p>
                        <div class="bax-review-items d-md-flex">
                            <button type="button" @click="goToAddPatient" class="bax-btn bax-btn-bordered bax-btn-bordered-blue">
                                Add more items
                            </button>
                            <ul class="d-md-flex ml-auto mt-3 mt-md-0">
                                <li v-if="!orderInfo.draftSaved">
                                    <button
                                            type="button"
                                            class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1"
                                            @click="openDraftOrderModal"
                                    >Save draft</button>
                                </li>
                                <li v-if="orderInfo.draftSaved">
                                    <button
                                            type="button"
                                            class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1"
                                            @click="openDeleteDraftModal"
                                    ><i class="icon-delete"></i>Delete draft</button>
                                </li>
                                <template v-if="authenticatedUser.baxterRoles.can_submit_orders">
                                    <li>
                                        <button
                                                @click="submitOrder"
                                                type="submit"
                                                class="bax-btn bax-btn-green mt-3 mt-md-0"
                                                :disabled="disableSubmitOrder"
                                        >Submit order</button>
                                    </li>
                                </template>
    <!--                            <li>-->
    <!--                                <button-->
    <!--                                        @click="cleanupOrder"-->
    <!--                                        type="submit"-->
    <!--                                        class="bax-btn bax-btn-green mt-3 mt-md-0"-->
    <!--                                >Cleanup Order</button>-->
    <!--                            </li>-->
                            </ul>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <vue-modal :open="submitModal" @close="closeSubmitModal">
            <div v-if="orderSubmitted === false">
                <div class="bax-icon bax-information d-flex align-items-center justify-content-center">
                    <i class="icon-information"></i>
                </div>
                <h2>Submit Order?</h2>
                <p v-if="!orderInfo.hasOverriddenStability">Your order will be submitted to our team for processing</p>
                <div class="textblock" v-if="orderInfo.hasOverriddenStability">
                    <p>Status of orders with no stability are <u>Pending</u> Baxter approval.</p>
                    <p>Once in <u>Reviewed</u>, the order is OK.</p><BR />
                    <p>You will be contacted if further information is required.</p>
                </div>
                <div class="textblock" v-if="includeReorderLines">
                    <p>Please review and edit re-ordered lines as required.</p>
                </div>

                <div class="bax-modal-action-items">
                    <ul class="d-md-flex justify-content-center">
                        <li>
                            <a href="#"
                                class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1"
                                @click.prevent="submitModal = false"
                            >Cancel</a>
                        </li>
                        <li>
                            <button
                                class="bax-btn bax-btn-green mt-3 mt-md-0"
                                @click="confirmSubmitOrder"
                            >Submit order</button>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-if="orderSubmitted">
                <div class="bax-icon bax-success d-flex align-items-center justify-content-center">
                    <i class="icon-tick"></i>
                </div>
                <h2>Order Submitted</h2>
                <p>Your order has been successfully submitted!</p>
                <div class="bax-modal-action-items">
                    <ul class="d-md-flex justify-content-center">
                        <li>
                            <router-link :to="{ name: isTPN() ? 'homeTPN' : 'home' }" class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1">
                                Take me home
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </vue-modal>

        <draft-order-modal :open="draftModal" @cancel="draftModal = false"></draft-order-modal>

        <vue-modal :open="errorModal" @close="errorModal = false">
            <h2>Order submission failed to save</h2>
            <p style="font-size: 14px; word-wrap: break-word;" v-html="errorMessage"></p>
            <div class="bax-modal-action-items">
                <ul class="d-md-flex justify-content-center">
                    <li>
                      <a href="#"
                         class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1"
                         @click.prevent="errorModal = false"
                      >Back</a>
                    </li>
                </ul>
            </div>
        </vue-modal>

        <vue-modal :open="errorMultiUser" @close="errorMultiUser = false">
            <h2>Order submission failed to save</h2>
            <p style="font-size: 14px; word-wrap: break-word;">Draft does not exist for this hospital.</p>
            <div class="bax-modal-action-items">
                <ul class="d-md-flex justify-content-center">
                        <li>
                            <router-link :to="{ name:'home' }" class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1">
                                Take me home
                            </router-link>
                        </li>
                </ul>
            </div>
        </vue-modal>

        <vue-modal :open="forceDupeSubmissionModal" @close="forceDupeSubmissionModal = false">
            <h2>Duplicate order detected</h2>
          <p style="font-size: 14px; word-wrap: break-word;">The Order Reference <strong>{{ orderInfo.orderRefView }}</strong> has been recently submitted.</p>
            <p style="font-size: 14px; word-wrap: break-word;">Are you sure you wish to resubmit it?</p>
          <div class="bax-modal-action-items">
            <ul class="d-md-flex justify-content-center">
              <li>
                <a href="#"
                   class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1"
                   @click.prevent="forceDupeSubmissionModal = false"
                >Cancel</a>
              </li>
              <li>
                <button
                  class="bax-btn bax-btn-green mt-3 mt-md-0"
                  @click="confirmSubmitDupeOrder"
                >Resubmit order</button>
              </li>
            </ul>
          </div>
        </vue-modal>

        <vue-modal :open="deleteDraftModalOpen">
            <div v-if="true">
                <div class="bax-icon bax-draft d-flex align-items-center justify-content-center">
                    <i class="icon-delete"></i>
                </div>
                <h2>Delete this draft order?</h2>
                <p>This Draft Order will be permanently removed</p>
                <div class="bax-modal-action-items">
                    <ul class="d-md-flex justify-content-center">
                        <li>
                            <vue-button color="default" @click="closeDeleteDraftModal">Cancel</vue-button>
                        </li>
                        <li>
                            <vue-button color="primary" @click="deleteDraftOrder">Delete Draft</vue-button>
                        </li>
                    </ul>
                </div>
            </div>
        </vue-modal>

    </app-layout>
</template>

<script>
import AppLayout from '@/components/layout/AppLayout.vue';
import OrderSummary from '@/components/order/OrderSummary/OrderSummary.vue';
import OrderService from '@/core/api/order/order.service';
import DraftOrderModal from '@/components/order/DraftOrder/DraftOrderModal.vue';
import { scrollPageToTop } from '@/core/helpers';
import BaxHeaderBanner from '@/components/layout/BaxHeaderBanner.vue';
import tpnMixin from '@/mixins/tpnMixin';
import { mapGetters } from 'vuex';

export default {
    name: 'OrderReviewComplete',
    mixins: [tpnMixin],
    components: {
        AppLayout,
        OrderSummary,
        DraftOrderModal,
        BaxHeaderBanner,
    },
    data() {
        return {
            processing: false,
            orderSubmitted: false,
            submitModal: false,
            draftModal: false,
            errorModal: false,
            errorMessage: '',
            payload: '',
            drugCount: 0,
            orderInfo: '',
            deleteDraftModalOpen: false,
            includeReorderLines: false,
            forceDupeSubmissionModal: false,
            forceDupeSubmissionAgreed: false,
            errorMultiUser: false,
        };
    },
    created() {
        scrollPageToTop();
        this.getOrderInfo();
    },
    computed: {
        ...mapGetters(['authenticatedUser']),
        disableSubmitOrder() {
            if (this.orderInfo.editRequired) {
                return true;
            }

            if (this.drugCount > 0) {
                return false;
            }
            return true;
        },
    },
    methods: {
        orderSummaryRefreshed() {
            this.getOrderInfo();
        },
        getOrderInfo() {
            const data = {};
            data.orderRef = this.$route.params.orderId;

            OrderService.orderCleanup(data).then(() => {
                OrderService.orderInfo(this.$route.params.orderId).then((res) => {
                    OrderService.validateOrder({
                        orderRef: this.$route.params.orderId,
                        validateOnly: true,
                    })
                        .then(() => {});

                    this.drugCount = res.drugCount;
                    this.orderInfo = res;
                    this.orderInfo.patients.forEach((p) => {
                            p.drugs.forEach((drug) => {
                                if (drug.reordered) {
                                    this.includeReorderLines = true;
                                }
                            });
                    });
                });
            });
        },
      goToAddPatient() {
            if (this.isTPN()) {
                this.$router.push({
                    name: 'drugDetailTPN',
                });
            } else {
                this.$router.push({
                    name: 'selectPatient',
                });
            }
      },

      goToDrugDetail() {
        const { patient } = this.$route.query;

        if (patient !== '' && typeof patient !== 'undefined') {
          this.$router.push({
            name: 'drugDetail',
            params: {
              patient,
            },
          });
        } else {
          this.$router.push({
            name: 'drugDetail',
          });
        }
      },
        cleanupOrder() {
            this.getOrderInfo();
        },
        submitOrder() {
            this.submitModal = true;
        },
        confirmSubmitOrder() {
            if (this.processing === true) {
                return;
            }

            this.processing = true;

            OrderService.submitOrder({
                orderRef: this.$route.params.orderId,
                forceDupeSubmission: this.forceDupeSubmissionAgreed,
            })
                .then(() => {
                    // eslint-disable-next-line no-console
                    this.submitModal = true;
                    this.orderSubmitted = true;
                    this.forceDupeSubmissionModal = false;
                })
                .catch((err) => {
                    if (err.response.data.message === 'Draft multi access') {
                        this.errorMultiUser = true;
                        this.orderSubmitted = false;
                        this.submitModal = false;
                    } else if (err.response.status === 400) {
                        this.submitModal = false;
                      this.forceDupeSubmissionModal = false;
                        this.errorModal = true;
                        this.errorMessage = err.response.data.message;
                    } else if (err.response.status === 409) {
                      this.orderSubmitted = false;
                        this.submitModal = false;
                        this.forceDupeSubmissionModal = true;
//                        this.errorModal = true;
//                        this.errorMessage = err.response.data.message;
                    } else {
                        this.submitModal = false;
                        this.forceDupeSubmissionModal = false;
                        this.errorModal = true;
                        this.errorMessage = err.response.data.message;
                    }
                })
                .then(() => {
                    this.processing = false;
                });
        },
        // Draft order modal
       confirmSubmitDupeOrder() {
            this.forceDupeSubmissionAgreed = true;
            this.confirmSubmitOrder();
        },
        openDraftOrderModal() {
            this.draftModal = true;
        },
        closeSubmitModal() {
            this.submitModal = false;
            this.orderSubmitted = false;
        },
        openDeleteDraftModal() {
            this.deleteDraftModalOpen = true;
        },
        closeDeleteDraftModal() {
            this.deleteDraftModalOpen = false;
        },
        deleteDraftOrder() {
            OrderService.deleteDraftOrder(this.$route.params.orderId).then(() => {
              if (this.isTPN()) {
                this.$router.push({ path: '/tpn/manage-orders', query: { order: 'draft' } });
              } else {
                this.$router.push({ path: '/manage-orders', query: { order: 'draft' } });
              }
            });
        },
    },
};
</script>
